import { render } from "./SetAccountContactStatusForm.vue?vue&type=template&id=b0dbdf60"
import script from "./SetAccountContactStatusForm.vue?vue&type=script&lang=js"
export * from "./SetAccountContactStatusForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__